const ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};

export {
  ALERT
};


// WEBPACK FOOTER //
// ./_src/js/model/msg/alert.js